import React from 'react';

import { Loader } from '../../Elements/Loader';

import './SummaryInfoInput.css';

export const SummaryInfoInput = ({ isLoading, summaryInfoLabel, content }) => {
  const formattedContent = typeof content === 'string' ? content?.split('_')?.join(' ') : content;
  return (
    <div className="summary-info-box-wrapper">
      <div className="summary-info-box-label">{summaryInfoLabel}</div>
      <div className="summary-info">
        {isLoading ? (
          <div className="loader-wrapper">
            <Loader size={15} />
          </div>
        ) : (
          formattedContent
        )}
      </div>
    </div>
  );
};
